export class ManagedBy {
    DepartmentID: string;
    DepartmentDivisionID: string;
    DepartmentDivisionName?: any;
    ExpertUserID?: any;
    ExpertName?: any;

    public constructor(init?: Partial<ManagedBy>) {
        Object.assign(this, init);
    }
}
